window.components.modalProduct = {
    selector: "[modal-product]",

    init: function () {
        this.events();
    },

    events: function () {
        $(this.selector).on("click", ".backshadow", this.close);
        $(this.selector).on("click", ".modal-close", this.close);
    },

    open: function (id) {
        $(window.components.modalProduct.selector).addClass("active");
        this.loadData(id);
    },

    close: function () {
        $(window.components.modalProduct.selector).removeClass("active");
    },

    loadData: function (id) {
        $(this.selector).find(".shops").html("");

        $.get(`/onde-comprar/${id}`, function (data) {
            window.components.modalProduct.setFields(data.data, data.lineData);
        });
    },

    setFields: function (data, lineData) {
        if (data.productLineId) {
            $(this.selector)
                .find(".modal-products-name")
                .html(data.name || "");
            $(this.selector)
                .find(".modal-products-description")
                .html(data.sellers[0].description || "");
            $(this.selector)
                .find(".modal-products-description-mobile")
                .html(data.sellers[0].description || "");
            $(this.selector)
                .find(".modal-products-image")
                .html(
                    `<img src="${
                        data.sellers[0].full_imageDetails_path || ""
                    }"></img>`
                );

            $(this.selector)
                .find(".modal-products-title")
                .html(lineData.title || "");
        }
        this.setItems(data.sellers);
    },

    setItems: function (items = []) {
        if (items.length) {
            let itemsHtml = ``;
            items.map((item) => { 
                if(item.isVisible == 1){                    
                    itemsHtml += `
                        <li>
                            <div class="shop-content">
                                <div class="shop-image">
                                    <img src="${item.full_image_path}">
                                </div>
                                <div class="shop-text">
                                    <div class="shop-name">${item.name}</div>
                                    ${
                                        item.value
                                            ? `<div class="shop-item-price">R$ ${item.value}</div>`
                                            : ""
                                    }
                                    
                                </div>
                            </div>
                            <a href="${
                                item.link
                            }" target="_blank" class="shop-button">
                                <span>Comprar</span>
                                <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.95975 4.64825C6.37025 4.27879 7.03582 4.27879 7.44633 4.64825C7.85683 5.01771 7.85683 5.61673 7.44633 5.98619L5.95975 4.64825ZM0.756709 9.33103L5.95975 4.64825L7.44633 5.98619L2.24329 10.669L0.756709 9.33103Z" fill="white" />
                                    <path d="M7.44633 5.01381C7.85683 5.38327 7.85683 5.98229 7.44633 6.35175C7.03582 6.72121 6.37025 6.72121 5.95974 6.35175L7.44633 5.01381ZM2.24329 0.331032L7.44633 5.01381L5.95974 6.35175L0.756709 1.66897L2.24329 0.331032Z" fill="white" />
                                </svg>
                            </a>
                        </li>
                    `;
                }
            });

            $(this.selector).find(".shops").html(itemsHtml);
        } else {
            $(this.selector)
                .find(".shops")
                .html(
                    "<li>Não foram encontradas ofertas para o produto selecionado</li>"
                );
        }
    },
};
